export default __webpack_public_path__ + "static/media/apps.e66f1cf0.svg";